import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import classes from "./Cobertura.module.css";

const logos = [
    "/Clients/bacardi.jpg",
    "/Clients/cementos-progreso.png",
    "/Clients/cerveza-gallo.png",
    "/Clients/cmi.png",
    "/Clients/chn.png",
    "/Clients/coca-cola.png",
    "/Clients/little-caesars.png",
    "/Clients/mass.jpg",
    "/Clients/tigo.png",
    "/Clients/pollo-campero.png",
    "/Clients/walmart.png",
    "/Clients/yaesta.png",
];

const Cobertura = () => {
    const beneficios = [
        {
            texto: "Retorno de inversión garantizado",
            subTexto: "Excelente relacion costo-beneficio, asegurando mayor posicionamiento"
        },
        {
            texto: "Conexión directa con el público",
            subTexto: "De manera efectiva a tu audiencia aprovechando diferentes opciones de programacion"
        },
        {
            texto: "Flexibilidad total",
            subTexto: "Personalización del mupi según identidad de marca, reforzando su posicionamiento y crear una conexión emocional auténtica"
        }
    ];
    const [indexActual, setIndexActual] = useState(0);
    const avanzar = () => {
            setIndexActual((prev) => (prev + 1) % beneficios.length);
    };
    const retroceder = () => {
            setIndexActual((prev) => (prev - 1 + beneficios.length) % beneficios.length);
    };
    const beneficio = beneficios[indexActual];    

    return (
        <section id="quienes-somos" className={classes.ubicaciones}>
            <div className={classes['container']}>
                {/* Titulo de la sección */}
                <motion.section
                    id="quienes-somos"
                    className={classes['quienes-somos']}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true, amount: 0.3 }}
                >
                <div className={classes.container}>
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2, duration: 0.6 }}
                        className={classes.titulo}
                    >
                        ¿Quiénes somos?
                    </motion.h2>
                    <motion.p 
                        className={classes.descripcion}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.6 }}
                        viewport={{ once: true }}
                        >
                        Más de 20 años creando experiencias publicitarias
                    </motion.p>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.6, duration: 0.6 }}
                        viewport={{ once: true }}
                        >
                        <p className={classes.descripcion}>
                            Somos una empresa constituida por socios con más de 20 años de experiencia
                            en el ámbito publicitario. Nos dedicamos a crear y comercializar
                            experiencias publicitarias innovadoras y efectivas.
                        </p>
                        <p className={classes.descripcion}>
                            Nuestra misión es transformar lo que nuestros clientes imaginan en una
                            realidad, siempre ajustándonos a sus necesidades y presupuesto.
                        </p>
                    </motion.div>  
                </div>
                </motion.section>

                {/* Grid */}
                <div className={classes.grid}>
                    {/* Izquierda: Imagen del mapa */}
                    <div className={classes.mapa}>
                    <img src="/img/mapa-pais.png" alt="Mapa Kraken Media" className={classes.mapaImagen} />
                    </div>
        
                    {/* Derecha: Textos divididos en dos */}
                    <div className={classes.textos}>
                        <div className={classes.textoArriba}>
                            <h2 className={classes.titulo}>Presencia Nacional</h2>
                            <p className={classes.descripcion}>
                                Estamos presentes en los principales municipios del país, llevando tu marca a todos los rincones.
                            </p>
                        </div>
        
                        <div className={classes.textoAbajo}>
                            <h2 className={classes.titulo}>+10 Departamentos Activos</h2>
                            <p className={classes.descripcion}>
                                Expandimos el alcance de tu comunicación a nivel nacional con nuestras soluciones estratégicas.
                            </p>
                        </div>
                    </div>
                </div>
                <div className={classes.grid}>
                    { /* Beneficios */}
                    <div className={classes.beneficios}>
                        <div className={classes['container-centrado']}>
                            <motion.h3 
                                className={classes.titulo}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}
                                viewport={{ once: true }}
                                >
                                ¿En qué te beneficias?
                            </motion.h3>
                            <div className={classes.navegador}>
                                <button onClick={retroceder}>⟵</button>

                                <AnimatePresence mode="wait">
                                    <motion.div
                                        key={beneficio.texto}
                                        className={classes['beneficio-card-unico']}
                                        initial={{ opacity: 0, y: 30 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -30 }}
                                        transition={{ duration: 0.4 }}
                                        >
                                        <div className={classes['texto-beneficio']}>
                                            <h3>{beneficio.texto}</h3>
                                            <p>{beneficio.subTexto}</p>
                                        </div>
                                    </motion.div>
                                </AnimatePresence>
                                <button onClick={avanzar}>⟶</button>
                            </div>                        
                        </div>
                    </div>
                    { /* Servicios que se ofrecen */}
                    <div className={classes.beneficios}>
                        <div className={classes['container-centrado']}>
                            <motion.h3 
                                className={classes.titulo}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}
                                viewport={{ once: true }}
                                >
                                ¿Qué ofrecemos?
                            </motion.h3>
                            <div className={classes['valor-lista']}>
                                <p>Canal de comunicación directo con el público.</p>
                                <p>Publicidad con tecnología de punta.</p>
                                <p>Eventos y activaciones de marca.</p>
                                <p>Creatividad personalizada y adaptable al presupuesto.</p>
                                <p>Convertimos ideas en experiencias reales.</p>
                            </div>
                        </div>
                    </div>      
                </div>
                { /* Carrusel de clientes */}
                <div className={classes.container}>
                    <motion.h2 
                        className={classes.titulo}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                        >
                        Empresas que confían en nosotros
                    </motion.h2>

                    <div className={classes['carrusel-envuelto']}>
                        <Swiper
                            modules={[Autoplay]}
                            slidesPerView={3}
                            spaceBetween={10}
                            loop={true}
                            autoplay={{ delay: 1000 }}
                            breakpoints={{
                                400: { slidesPerView: 2 },
                                1024: { slidesPerView: 5 },
                            }}
                            >
                            {logos.map((src, index) => (
                                <SwiperSlide key={index}>
                                    <div className={classes['logo-slide']}>
                                        <img src={src} alt={`Cliente ${index + 1}`} />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Cobertura;